__turbopack_context__.v({
  "adminAvatar": "_-eYKW_adminAvatar",
  "directorAvatar": "_-eYKW_directorAvatar",
  "dropdown": "_-eYKW_dropdown",
  "homeBenefitsSectionRoleDropdownItem": "_-eYKW_homeBenefitsSectionRoleDropdownItem",
  "img2": "_-eYKW_img2",
  "img3": "_-eYKW_img3",
  "img4": "_-eYKW_img4",
  "input": "_-eYKW_input",
  "name": "_-eYKW_name",
  "officerAvatar": "_-eYKW_officerAvatar",
  "popoverCore": "_-eYKW_popoverCore",
  "rightIcon": "_-eYKW_rightIcon",
  "role2": "_-eYKW_role2",
  "roleDropdown": "_-eYKW_roleDropdown",
  "svg__bHqhZ": "_-eYKW_svg__bHqhZ",
  "svg__fiA3J": "_-eYKW_svg__fiA3J",
  "svg__wgr2E": "_-eYKW_svg__wgr2E",
  "text10": "_-eYKW_text10",
});
